import React from 'react';
import styled from 'App/styled';
import { useTheme } from 'emotion-theming';
import { TrendingSearch } from 'types/searchSuggestion';


interface ButtonProps {
  textColor: string;
}

const TopSearches = styled.div`
  background-color: #ffffff;
  margin-top: 10px;
`;

const Title = styled.h4`
  ${({ theme }) => theme.typography.subTitleMedium};
  color: #3f414d;
  padding: 15px;
  margin: 0;
`;

const Button = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: ${({ textColor }: ButtonProps) => textColor};
  margin: 0;
  border: none;
  padding: 12px 16px;
  background: #fff;
  text-align: left;
  &:active {
    background: #e6e9eb;
  }
`;

const Icon = styled.span`
  height: 24px;
  width: 24px;
  margin-right: 16px;
  opacity: 0.48;
`;

const Text = styled.span`
  width: 100%;
  color: #001325;
  margin-right: 48px;
  ${({ theme }) => theme.typography.bodyMedium};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

interface TrendingSearchProps {
  handleClick: (searchItem: TrendingSearch, position: number) => void;
  trendingSearches: TrendingSearch[];
  trendingSearchesToShow: number;
  searchSuggestionIcons: {trending: string};
}

function View({
  handleClick,
  trendingSearches,
  trendingSearchesToShow,
  searchSuggestionIcons,
}: TrendingSearchProps) {
  const theme: Theme = useTheme();
  if (
    (trendingSearchesToShow < 1)
    || (trendingSearches && (!(trendingSearches.length > 0)))
  ) {
    return null;
  }

  const clickHandler = (searchItem: TrendingSearch, position: number) => {
    handleClick(searchItem, position);
  };

  const { trending } = searchSuggestionIcons;

  const itemsToShow = trendingSearches.slice(0, trendingSearchesToShow);
  return (
    <TopSearches>
      <Title>Trending Searches</Title>
      {
        itemsToShow.map((search, index) => {
          const { q } = search;
          return (
            <Button
            textColor={theme.darkGrey}
            type="button"
            key={q}
            onClick={() => clickHandler(search, index + 1)}
            >
              <Icon>
                <img src={ trending } alt="trending icon" />
              </Icon>
              <Text>
                {q}
              </Text>
            </Button>
          );
        })
      }
    </TopSearches>
  );
}

export default View;
